/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {Card , ProgressBar , Breadcrumb, Button} from 'react-bootstrap'
import {ExamResultsService} from '../services';
import {ExamResultsStore, ProductStore} from '../store';
import GeneralTable from '../components/general_table.js';
import Constants from '../constants.js';
import Translation from '../store/internationalization-store.js';

export default class ExamTests extends React.Component {
 
    constructor(props) {
        super();
        this.props = props;
        this.state = {
            tab:"students",
            toggle:false,
            loading:false,
            lastSelected:undefined
        };
    }
    componentWillMount(){
        //GET STUFF HERE
        ExamResultsService.getAccountResults();
    }

    componentDidMount(){
        //GET STUFF HERE
        ExamResultsStore.on(Constants.GET_ACCOUNT_RESULTS , ()=>{
            this.setState({examResults:ExamResultsStore.accountResults})
        })

    }

    renderMinorLink(cell, row){

        return <a href={"#/examTests/minor/"+row.uid + "/"+row.test_uid}>{cell} {row.last_name}</a>
    }

    getUserName() {
        if (ProductStore.userData == undefined || ProductStore.userData.accountSettings == undefined 
            || ProductStore.userData.accountSettings['cefrUsername'] == undefined) {
            return "N/A";
        }
        return ProductStore.userData.accountSettings['cefrUsername'];	
    }

    getCurrentTimer = function(currentTime) {
        var seconds = currentTime % 60;
        var minutes = Math.floor(currentTime % (60 * 60) / 60);
        var hours = Math.floor(currentTime / (60 * 60));
        return hours + "h:"+minutes+"m:"+seconds+"s";
    }

    resources(){
        var username = "";
        if (ProductStore.userData != undefined) {
            username = this.getUserName();
        }
        if  (window.location.href.indexOf("gamma") > -1) {
            window.open('https://gamma.languagenut.com/resources/#/LoginScreen?username='+username,'_blank');
        } else if (window.location.href.indexOf(".cn") > -1) {
            window.open('https://languagenut.cn/resources/#/LoginScreen?username='+username,'_blank');
        }  else if (window.location.href.indexOf("asia") > -1) {
            window.open('https://asia.languagenut.com/resources/#/LoginScreen?username='+username,'_blank');
        } else {
            window.open('https://languagenut.com/resources/#/LoginScreen?username='+username,'_blank');
        }
    }

    render(){

        if(this.state.loading) return <ProgressBar animated now={45} />
        
        if (!this.state.students) {
           // return "";
        }

        let columns = [
            {

                dataField: 'first_name',
                text: "Student Name",
                formatter: this.renderMinorLink.bind(this)
            },{
                dataField: 'uid',
                text: "Login ID",
            },{
                dataField: 'end_score',
                text: "English Level Achieved",
            },{
                dataField: 'test_type',
                text: "Test Taken",
            },{
                dataField: 'taken',
                text: "Completed Date",
                formatter:(cell)=>{
                    return (new Date(cell.replace(" ", "T"))).format('d-m-Y')
                }
            },{
                dataField: 'age',
                text: "Student Age",
            },{
                dataField: 'language',
                text: "Student Language",
                formatter:(cell)=>{

                    if(cell == 'Mandarin Hanzi') return 'Chinese';

                    return cell
                }
            },{
                dataField: 'gender',
                text: "Student Gender",
            },{
                dataField: 'average',
                text: "Average Score",
                formatter: (cell , row)=>{
                    return cell + "%"
                }
            },{
                dataField: 'total_time',
                text: "Total Time",
                formatter: (cell , row)=>{
                    return this.getCurrentTimer(cell)
                }
            }
        ];

        return <div>
            <Breadcrumb>
                <Breadcrumb.Item active><b>Test Results</b></Breadcrumb.Item>
            </Breadcrumb>
            <Card body>
            <div>
            
            <GeneralTable pageSize={40} component={<Button style={{marginRight:"10px"}} onClick={this.resources.bind(this)}>{Translation.get(0 , 'Test Url')}</Button>}
                    bordered={ true } keyField='id' data={ this.state.examResults || [] } columns={columns} />
            </div>
        </Card></div>
    }
}